import React, { Component } from 'react';
import {connect} from 'react-redux'
import flow from 'lodash/flow';

import withStyles from 'material-ui/styles/withStyles'
import MuiSnackbar from 'material-ui/Snackbar'
import {getShowMessage, getMessage} from '../selectors'
import {closewMessage} from '../actions'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'
import Button from 'material-ui/Button'
//import CheckIcon from 'material-ui-icons/Check'
//import green from 'material-ui/colors/green'

const styles = theme => ({
    container: {
        margin: theme.spacing.normal
    },
    close: {
        width: theme.spacing.unit * 4,
        height: theme.spacing.unit * 4,
    },
    info: {
        //color: green['500']
    },
    warn: {
        //color: theme.palette.error['100']
    },
    error: {
        color: theme.palette.error['500']
    }
})

const AUTO_HIDE = 6000

class Snackbar extends Component {

    componentDidMount() {
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        if(this.timout) clearTimeout(this.timout)
        this.props.handleClose();
    };

    handleAction = (action) => {
        this.props.handleAction(action)
        this.props.handleClose();
    }

    mouseEnter = () => {
        if(this.timout) clearTimeout(this.timout)
    }

    mouseLeave = () => {
        this.timout = setTimeout(this.handleClose, AUTO_HIDE/2)
    }

    componentDidUpdate() {
        if(this.props.show) {
            if(this.timout) clearTimeout(this.timout)
            this.timout = setTimeout(this.handleClose, AUTO_HIDE)
        }
    }

    render() {
        const {classes, show, message} = this.props;

        return <MuiSnackbar
            className={classes.container}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={show}

            onClose={this.handleClose}
            SnackbarContentProps={{
                'aria-describedby': 'message-id',
            }}
            onMouseEnter={this.mouseEnter}
            onMouseLeave={this.mouseLeave}
            message={<span id="message-id" className={message && message.type && classes[message.type]}>{message && message.message}</span>}
            action={[
                message && message.actions && message.actions.map(action =>
                    <Button key={action.title} color="accent" dense onClick={this.handleAction}>
                        {action.title}
                    </Button>),
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={this.handleClose}
                >
                    <CloseIcon />
                </IconButton>,
            ]}
        />
    }
};

const mapStateToProps = (state) => {
    return {
        show: getShowMessage(state),
        message: getMessage(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleClose: () => {
            dispatch( closewMessage() );
        },
        handleAction: (action) => {
            dispatch( action() );
        },
    }
}


export default flow(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(Snackbar);




// WEBPACK FOOTER //
// ./src/components/Snackbar.js